import { render, staticRenderFns } from "./toggleConf.vue?vue&type=template&id=2db2d75e&"
import script from "./toggleConf.vue?vue&type=script&lang=js&"
export * from "./toggleConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports